import { useTranslation } from "react-i18next"

import { SortBuilderProps } from "~/components/SortBuilder"
import { useHeaderControlsContext } from "~/components/contexts/useHeaderControlsContext"
import { FindProductionSitesForBrandsRequestSortsDto } from "~/gen/api"

export const useBuildProductionSiteSorts =
  (): SortBuilderProps<FindProductionSitesForBrandsRequestSortsDto> => {
    const { t } = useTranslation("supplier")
    const { sorts, setSorts } = useHeaderControlsContext()
    return {
      sorts,
      setSorts,
      options: [
        { label: t("productionSites.sorts.name"), value: "name" },
        { label: t("productionSites.sorts.country"), value: "country" },
        { label: t("productionSites.sorts.address"), value: "address" },
        {
          label: t("productionSites.sorts.internalCode"),
          value: "internalCode",
        },
        { label: t("productionSites.sorts.email"), value: "email" },
      ],
    }
  }
